import React from 'react'
import { View, StyleSheet } from '@react-pdf/renderer'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'
import { Line } from './Line'
import Text from './Text'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginBottom: 8,
    flexGrow: 1,
  },
  verticalLine: {
    width: 4,
    height: '100%',
    borderRadius: '50%',
  },
  line: {
    marginBottom: 8,
  },
  text: {
    fontSize: 12,
    flex: 2,
    marginLeft: 16,
    maxWidth: 374,
  },
})

const SugestionLine = ({ text, status, color }) => (
  <View>
    <View style={styles.container}>
      <View style={[styles.verticalLine, { backgroundColor: color }]} />
      <Text style={[{ color: colors.strongGray }, styles.text]}>{text}</Text>
      <View style={{ display: 'flex', alignItems: 'flex-end', flex: 1 }}>
        {status(color)}
      </View>
    </View>
    <Line style={styles.line} />
  </View>
)

SugestionLine.propTypes = {
  text: PropTypes.string.isRequired,
  status: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
}

export default SugestionLine
